module.exports = __webpack_public_path__ + "img/logo_transparent_background.e65ed50a.png";